var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEgg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_3",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 128 128",
    style: {
      enableBackground: "new 0 0 128 128"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F2A05B"
    },
    d: "M63.43,4.51c31.68-0.07,51.67,51.46,43.78,84.12c-6.98,28.92-27.03,34.91-43.08,34.91 s-35.54-7.78-43.08-33.79C12.33,59.63,33.87,4.58,63.43,4.51z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FECC88"
    },
    d: "M39.26,29.03c-3.8,6.07-7.63,13.71-8.45,20.08c-1.5,11.73,7.13,13.05,10.14,7.23 s6.09-11.71,10.98-19.52c6.76-10.79,17.83-18.02,12.39-22.71S47.24,16.27,39.26,29.03z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#D47858"
    },
    cx: 91.4,
    cy: 43.58,
    rx: 2.02,
    ry: 2.06
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.3804 -0.9248 0.9248 0.3804 -30.1897 143.0475)",
    style: {
      fill: "#D47858"
    },
    cx: 91.66,
    cy: 94.05,
    rx: 2.19,
    ry: 2.18
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.3804 -0.9248 0.9248 0.3804 -74.7461 94.1799)",
    style: {
      fill: "#D47858"
    },
    cx: 32.91,
    cy: 102.87,
    rx: 2.04,
    ry: 2.04
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.8879 -0.4601 0.4601 0.8879 -17.8379 51.94)",
    style: {
      fill: "#D47858"
    },
    cx: 97.65,
    cy: 62.57,
    rx: 3.07,
    ry: 2.7
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.8879 -0.4601 0.4601 0.8879 -33.4526 41.5484)",
    style: {
      fill: "#D47858"
    },
    cx: 68.52,
    cy: 89.41,
    rx: 3.07,
    ry: 2.7
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.6235 -0.7818 0.7818 0.6235 -57.1611 89.9336)",
    style: {
      fill: "#D47858"
    },
    cx: 64.79,
    cy: 104.32,
    rx: 3.23,
    ry: 2.7
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.6645 -0.7473 0.7473 0.6645 -62.392 75.0571)",
    style: {
      fill: "#D47858"
    },
    cx: 52.39,
    cy: 107.01,
    rx: 3.58,
    ry: 3.46
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEgg);
export default __webpack_public_path__ + "static/media/egg.2f962e76aa79e7331227eb1d3b26c602.svg";
export { ForwardRef as ReactComponent };